module.exports = __webpack_public_path__ + "media/images/icons/chevron_left-7a2f3f59d9b60a151024c8d203363c87.svg";